var chunkToChildrenMap = {
	"7867": [
		2410,
		4699,
		952,
		6264,
		5993,
		7760
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));